import React, { useState } from 'react';
import {
  View,
  Text,
  ScrollView,
  Image,
  TouchableOpacity,
  useColorScheme,
} from 'react-native';
import { Ionicons } from '@expo/vector-icons';

const ChallengeDetailScreen = ({ route, navigation }) => {
  const { challengeId } = route.params;
  const isDarkMode = useColorScheme() === 'dark';
  const [isJoined, setIsJoined] = useState(false);

  // 模拟挑战数据
  const challenge = {
    id: challengeId,
    title: '30天低糖饮食',
    description: '30天内控制每日糖分摄入不超过25克，减少精制糖的摄入，提高胰岛素敏感性，改善身体健康状况。',
    category: 'diet',
    difficulty: 'medium',
    duration: '30天',
    startDate: '2023年6月1日',
    endDate: '2023年6月30日',
    progress: 70,
    daysLeft: 9,
    participants: 128,
    creator: {
      name: '营养师小王',
      avatar: 'https://randomuser.me/api/portraits/men/29.jpg',
      isOfficial: true,
    },
    rules: [
      '每日记录所有食物摄入',
      '计算并控制每日糖分摄入不超过25克',
      '避免添加糖和精制糖',
      '限制含糖饮料和甜点',
      '每周至少分享一次进展'
    ],
    rewards: {
      points: 300,
      badge: '低糖生活达人',
      healthBenefits: [
        '稳定血糖水平',
        '减少炎症反应',
        '提高能量水平',
        '改善皮肤状况'
      ]
    },
    participants_data: [
      {
        id: 'p1',
        name: '李健康',
        avatar: 'https://randomuser.me/api/portraits/men/32.jpg',
        progress: 75,
      },
      {
        id: 'p2',
        name: '小丽',
        avatar: 'https://randomuser.me/api/portraits/women/44.jpg',
        progress: 68,
      },
      {
        id: 'p3',
        name: '健身教练',
        avatar: 'https://randomuser.me/api/portraits/men/62.jpg',
        progress: 82,
      },
    ],
    leaderboard: [
      {
        id: 'p3',
        name: '健身教练',
        avatar: 'https://randomuser.me/api/portraits/men/62.jpg',
        score: 86,
      },
      {
        id: 'p1',
        name: '李健康',
        avatar: 'https://randomuser.me/api/portraits/men/32.jpg',
        score: 79,
      },
      {
        id: 'p2',
        name: '小丽',
        avatar: 'https://randomuser.me/api/portraits/women/44.jpg',
        score: 72,
      },
    ],
    tips: [
      '阅读食品标签，注意隐藏糖的名称',
      '选择全食物而不是加工食品',
      '使用香料增加食物风味，而不是添加糖',
      '多摄入蛋白质和健康脂肪，减少糖瘾',
      '保持充分水分，有时口渴会被误认为是对糖的渴望'
    ],
  };

  // 获取挑战类别图标
  const getCategoryIcon = (category) => {
    switch (category) {
      case 'diet':
        return <Ionicons name="nutrition" size={18} color="#ec4899" />;
      case 'exercise':
        return <Ionicons name="fitness" size={18} color="#2563eb" />;
      case 'habit':
        return <Ionicons name="calendar" size={18} color="#8b5cf6" />;
      default:
        return <Ionicons name="trophy" size={18} color="#f59e0b" />;
    }
  };

  // 获取难度级别样式
  const getDifficultyStyle = (difficulty) => {
    switch (difficulty) {
      case 'easy':
        return { color: '#10b981', backgroundColor: '#10b98120' };
      case 'medium':
        return { color: '#f59e0b', backgroundColor: '#f59e0b20' };
      case 'hard':
        return { color: '#ef4444', backgroundColor: '#ef444420' };
      default:
        return { color: '#6b7280', backgroundColor: '#6b728020' };
    }
  };

  const handleJoinChallenge = () => {
    setIsJoined(!isJoined);
  };

  return (
    <ScrollView 
      style={{ 
        flex: 1, 
        backgroundColor: isDarkMode ? '#1f2937' : '#f9fafb',
      }}
    >
      <View style={{ padding: 16 }}>
        {/* 头部 */}
        <View style={{ 
          flexDirection: 'row', 
          alignItems: 'center',
          marginBottom: 16, 
        }}>
          <TouchableOpacity
            style={{ 
              width: 32, 
              height: 32, 
              borderRadius: 16,
              backgroundColor: isDarkMode ? '#374151' : '#f3f4f6',
              justifyContent: 'center',
              alignItems: 'center',
              marginRight: 16,
            }}
            onPress={() => navigation.goBack()}
          >
            <Ionicons 
              name="arrow-back" 
              size={18}
              color={isDarkMode ? 'white' : '#1f2937'}
            />
          </TouchableOpacity>

          <Text style={{ 
            fontSize: 18,
            fontWeight: 'bold',
            color: isDarkMode ? 'white' : '#1f2937',
          }}>
            挑战详情
          </Text>
        </View>

        {/* 挑战卡片 */}
        <View style={{ 
          backgroundColor: isDarkMode ? '#374151' : 'white',
          borderRadius: 16,
          padding: 20,
          marginBottom: 20,
          shadowColor: '#000',
          shadowOffset: { width: 0, height: 1 },
          shadowOpacity: 0.1,
          shadowRadius: 2,
          elevation: 2,
        }}>
          {/* 标签 */}
          <View style={{ flexDirection: 'row', marginBottom: 12 }}>
            <View style={{
              flexDirection: 'row',
              alignItems: 'center',
              backgroundColor: isDarkMode ? '#4b5563' : '#f3f4f6',
              paddingHorizontal: 8,
              paddingVertical: 4,
              borderRadius: 12,
              marginRight: 8,
            }}>
              {getCategoryIcon(challenge.category)}
              <Text style={{
                fontSize: 12,
                marginLeft: 4,
                color: isDarkMode ? '#d1d5db' : '#6b7280',
              }}>
                {challenge.category === 'diet' ? '饮食' :
                  challenge.category === 'exercise' ? '运动' : '习惯'}
              </Text>
            </View>

            <View style={{
              paddingHorizontal: 8,
              paddingVertical: 4,
              borderRadius: 12,
              backgroundColor: getDifficultyStyle(challenge.difficulty).backgroundColor,
            }}>
              <Text style={{
                fontSize: 12,
                color: getDifficultyStyle(challenge.difficulty).color,
              }}>
                {challenge.difficulty === 'easy' ? '简单' :
                  challenge.difficulty === 'medium' ? '中等' : '困难'}
              </Text>
            </View>
          </View>

          {/* 标题 */}
          <Text style={{ 
            fontSize: 24,
            fontWeight: 'bold',
            color: isDarkMode ? 'white' : '#1f2937',
            marginBottom: 8,
          }}>
            {challenge.title}
          </Text>

          {/* 描述 */}
          <Text style={{ 
            fontSize: 16,
            color: isDarkMode ? '#d1d5db' : '#4b5563',
            lineHeight: 24,
            marginBottom: 16,
          }}>
            {challenge.description}
          </Text>

          {/* 创建者信息 */}
          <View style={{ 
            flexDirection: 'row', 
            alignItems: 'center',
            marginBottom: 16,
          }}>
            <Image 
              source={{ uri: challenge.creator.avatar }} 
              style={{ 
                width: 36, 
                height: 36, 
                borderRadius: 18,
                marginRight: 10, 
              }} 
            />
            <View style={{ flex: 1 }}>
              <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                <Text style={{ 
                  fontWeight: 'bold',
                  color: isDarkMode ? 'white' : '#1f2937',
                  marginRight: 6,
                }}>
                  {challenge.creator.name}
                </Text>
                {challenge.creator.isOfficial && (
                  <View style={{
                    flexDirection: 'row',
                    alignItems: 'center',
                    backgroundColor: isDarkMode ? '#4b5563' : '#e0f2fe',
                    paddingHorizontal: 6,
                    paddingVertical: 2,
                    borderRadius: 10,
                  }}>
                    <Ionicons name="shield-checkmark" size={12} color="#2563eb" />
                    <Text style={{
                      fontSize: 10,
                      marginLeft: 2,
                      color: '#2563eb',
                    }}>
                      官方
                    </Text>
                  </View>
                )}
              </View>
              <Text style={{ 
                fontSize: 12,
                color: isDarkMode ? '#d1d5db' : '#6b7280',
              }}>
                发起者
              </Text>
            </View>
          </View>

          {/* 时间信息 */}
          <View style={{ 
            flexDirection: 'row',
            justifyContent: 'space-between',
            marginBottom: 16,
          }}>
            <View>
              <Text style={{ 
                fontSize: 12,
                color: isDarkMode ? '#d1d5db' : '#6b7280',
                marginBottom: 4,
              }}>
                开始日期
              </Text>
              <Text style={{ 
                fontWeight: 'bold',
                color: isDarkMode ? 'white' : '#1f2937',
              }}>
                {challenge.startDate}
              </Text>
            </View>
            <View>
              <Text style={{ 
                fontSize: 12,
                color: isDarkMode ? '#d1d5db' : '#6b7280',
                marginBottom: 4,
              }}>
                结束日期
              </Text>
              <Text style={{ 
                fontWeight: 'bold',
                color: isDarkMode ? 'white' : '#1f2937',
              }}>
                {challenge.endDate}
              </Text>
            </View>
            <View>
              <Text style={{ 
                fontSize: 12,
                color: isDarkMode ? '#d1d5db' : '#6b7280',
                marginBottom: 4,
              }}>
                持续时间
              </Text>
              <Text style={{ 
                fontWeight: 'bold',
                color: isDarkMode ? 'white' : '#1f2937',
              }}>
                {challenge.duration}
              </Text>
            </View>
          </View>

          {/* 进度条 */}
          <View style={{ marginBottom: 16 }}>
            <View style={{ 
              flexDirection: 'row', 
              justifyContent: 'space-between', 
              marginBottom: 6,
            }}>
              <Text style={{ fontSize: 12, color: isDarkMode ? '#d1d5db' : '#6b7280' }}>
                进度: {challenge.progress}%
              </Text>
              <Text style={{ fontSize: 12, color: isDarkMode ? '#d1d5db' : '#6b7280' }}>
                剩余 {challenge.daysLeft} 天
              </Text>
            </View>
            <View style={{
              height: 8,
              backgroundColor: isDarkMode ? '#4b5563' : '#f3f4f6',
              borderRadius: 4,
              overflow: 'hidden',
            }}>
              <View style={{
                width: `${challenge.progress}%`,
                height: '100%',
                backgroundColor: '#2563eb',
                borderRadius: 4,
              }} />
            </View>
          </View>

          {/* 参与者 */}
          <View style={{ 
            flexDirection: 'row', 
            alignItems: 'center',
            marginBottom: 20,
          }}>
            <View style={{ flexDirection: 'row' }}>
              {challenge.participants_data.slice(0, 3).map((person, index) => (
                <Image
                  key={person.id}
                  source={{ uri: person.avatar }}
                  style={{
                    width: 32,
                    height: 32,
                    borderRadius: 16,
                    marginLeft: index > 0 ? -12 : 0,
                    borderWidth: 2,
                    borderColor: isDarkMode ? '#374151' : 'white',
                  }}
                />
              ))}
            </View>
            <Text style={{
              marginLeft: 8,
              fontSize: 14,
              color: isDarkMode ? '#d1d5db' : '#6b7280',
            }}>
              {challenge.participants} 人参与
            </Text>
          </View>

          {/* 参与按钮 */}
          <TouchableOpacity
            style={{
              backgroundColor: isJoined ? '#10b981' : '#2563eb',
              paddingVertical: 12,
              borderRadius: 12,
              alignItems: 'center',
            }}
            onPress={handleJoinChallenge}
          >
            <Text style={{ 
              color: 'white', 
              fontWeight: 'bold',
              fontSize: 16,
            }}>
              {isJoined ? '已参与' : '参与挑战'}
            </Text>
          </TouchableOpacity>
        </View>

        {/* 挑战规则 */}
        <View style={{ marginBottom: 20 }}>
          <Text style={{ 
            fontSize: 18,
            fontWeight: 'bold',
            color: isDarkMode ? 'white' : '#1f2937',
            marginBottom: 12,
          }}>
            挑战规则
          </Text>
          <View style={{ 
            backgroundColor: isDarkMode ? '#374151' : 'white',
            borderRadius: 16,
            padding: 16,
            shadowColor: '#000',
            shadowOffset: { width: 0, height: 1 },
            shadowOpacity: 0.1,
            shadowRadius: 2,
            elevation: 2,
          }}>
            {challenge.rules.map((rule, index) => (
              <View 
                key={index}
                style={{ 
                  flexDirection: 'row', 
                  marginBottom: index < challenge.rules.length - 1 ? 12 : 0,
                }}
              >
                <View style={{ 
                  width: 24,
                  height: 24,
                  borderRadius: 12,
                  backgroundColor: '#2563eb',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginRight: 12,
                  marginTop: 2,
                }}>
                  <Text style={{ color: 'white', fontWeight: 'bold', fontSize: 12 }}>
                    {index + 1}
                  </Text>
                </View>
                <Text style={{ 
                  flex: 1,
                  color: isDarkMode ? 'white' : '#1f2937',
                  lineHeight: 20,
                }}>
                  {rule}
                </Text>
              </View>
            ))}
          </View>
        </View>

        {/* 排行榜 */}
        <View style={{ marginBottom: 20 }}>
          <Text style={{ 
            fontSize: 18,
            fontWeight: 'bold',
            color: isDarkMode ? 'white' : '#1f2937',
            marginBottom: 12,
          }}>
            参与者排行
          </Text>
          <View style={{ 
            backgroundColor: isDarkMode ? '#374151' : 'white',
            borderRadius: 16,
            padding: 16,
            shadowColor: '#000',
            shadowOffset: { width: 0, height: 1 },
            shadowOpacity: 0.1,
            shadowRadius: 2,
            elevation: 2,
          }}>
            {challenge.leaderboard.map((person, index) => (
              <View 
                key={person.id}
                style={{ 
                  flexDirection: 'row', 
                  alignItems: 'center',
                  paddingVertical: 10,
                  borderBottomWidth: index < challenge.leaderboard.length - 1 ? 1 : 0,
                  borderBottomColor: isDarkMode ? '#4b5563' : '#f3f4f6',
                }}
              >
                <View style={{ 
                  width: 24,
                  height: 24,
                  borderRadius: 12,
                  backgroundColor: index === 0 ? '#f59e0b' : (index === 1 ? '#94a3b8' : '#d97706'),
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginRight: 12,
                }}>
                  <Text style={{ color: 'white', fontWeight: 'bold', fontSize: 12 }}>
                    {index + 1}
                  </Text>
                </View>
                <Image 
                  source={{ uri: person.avatar }} 
                  style={{ 
                    width: 40, 
                    height: 40, 
                    borderRadius: 20,
                    marginRight: 12, 
                  }} 
                />
                <View style={{ flex: 1 }}>
                  <Text style={{ 
                    fontWeight: 'bold',
                    color: isDarkMode ? 'white' : '#1f2937',
                  }}>
                    {person.name}
                  </Text>
                </View>
                <Text style={{ 
                  fontSize: 16,
                  fontWeight: 'bold',
                  color: index === 0 ? '#f59e0b' : (isDarkMode ? 'white' : '#1f2937'),
                }}>
                  {person.score}分
                </Text>
              </View>
            ))}
          </View>
        </View>

        {/* 挑战奖励 */}
        <View style={{ marginBottom: 20 }}>
          <Text style={{ 
            fontSize: 18,
            fontWeight: 'bold',
            color: isDarkMode ? 'white' : '#1f2937',
            marginBottom: 12,
          }}>
            挑战奖励
          </Text>
          <View style={{ 
            backgroundColor: isDarkMode ? '#374151' : 'white',
            borderRadius: 16,
            padding: 16,
            shadowColor: '#000',
            shadowOffset: { width: 0, height: 1 },
            shadowOpacity: 0.1,
            shadowRadius: 2,
            elevation: 2,
          }}>
            <View style={{ 
              flexDirection: 'row',
              marginBottom: 16,
            }}>
              <View style={{
                width: 48,
                height: 48,
                borderRadius: 24,
                backgroundColor: '#2563eb20',
                justifyContent: 'center',
                alignItems: 'center',
                marginRight: 16,
              }}>
                <Ionicons name="trophy" size={24} color="#2563eb" />
              </View>
              <View>
                <Text style={{ 
                  fontSize: 16,
                  fontWeight: 'bold',
                  color: isDarkMode ? 'white' : '#1f2937',
                  marginBottom: 4,
                }}>
                  完成奖励
                </Text>
                <Text style={{ 
                  color: isDarkMode ? '#d1d5db' : '#6b7280',
                }}>
                  获得 {challenge.rewards.points} 积分和"{challenge.rewards.badge}"徽章
                </Text>
              </View>
            </View>

            <Text style={{ 
              fontSize: 16,
              fontWeight: 'bold',
              color: isDarkMode ? 'white' : '#1f2937',
              marginBottom: 8,
            }}>
              健康收益
            </Text>
            {challenge.rewards.healthBenefits.map((benefit, index) => (
              <View 
                key={index}
                style={{ 
                  flexDirection: 'row', 
                  marginBottom: index < challenge.rewards.healthBenefits.length - 1 ? 8 : 0,
                }}
              >
                <Ionicons 
                  name="checkmark-circle" 
                  size={20} 
                  color="#10b981" 
                  style={{ marginRight: 8 }} 
                />
                <Text style={{ 
                  color: isDarkMode ? '#d1d5db' : '#4b5563',
                }}>
                  {benefit}
                </Text>
              </View>
            ))}
          </View>
        </View>

        {/* 挑战小贴士 */}
        <View style={{ marginBottom: 20 }}>
          <Text style={{ 
            fontSize: 18,
            fontWeight: 'bold',
            color: isDarkMode ? 'white' : '#1f2937',
            marginBottom: 12,
          }}>
            挑战小贴士
          </Text>
          <View style={{ 
            backgroundColor: isDarkMode ? '#374151' : '#f0f9ff',
            borderRadius: 16,
            padding: 16,
            shadowColor: '#000',
            shadowOffset: { width: 0, height: 1 },
            shadowOpacity: 0.1,
            shadowRadius: 2,
            elevation: 2,
          }}>
            {challenge.tips.map((tip, index) => (
              <View 
                key={index}
                style={{ 
                  flexDirection: 'row', 
                  marginBottom: index < challenge.tips.length - 1 ? 10 : 0,
                }}
              >
                <Ionicons 
                  name="bulb-outline" 
                  size={18} 
                  color="#3b82f6" 
                  style={{ marginRight: 8, marginTop: 2 }} 
                />
                <Text style={{ 
                  flex: 1,
                  color: isDarkMode ? 'white' : '#1f2937',
                }}>
                  {tip}
                </Text>
              </View>
            ))}
          </View>
        </View>
      </View>
    </ScrollView>
  );
};

export default ChallengeDetailScreen; 